import { render } from "./SymptomReportDrawView.vue?vue&type=template&id=3cc42398&scoped=true"
import script from "./SymptomReportDrawView.vue?vue&type=script&lang=js"
export * from "./SymptomReportDrawView.vue?vue&type=script&lang=js"

import "./SymptomReportDrawView.vue?vue&type=style&index=0&id=3cc42398&lang=scss&scoped=true"
import "./SymptomReportDrawView.vue?vue&type=style&index=1&id=3cc42398&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cc42398"]])

export default __exports__